import React from 'react'
import { Link } from 'react-router-dom'

import { Icon } from 'src/components/ui'

import styles from './BalanceAction.module.scss'

interface Props {
  variant: string
  text: string
  path: string
}

const BalanceAction: React.FC<Props> = ({ variant, text, path }) => {
  return (
    <Link to={path} className={styles.icon}>
      <div>
        <Icon name={variant} />
      </div>
      <p>{text}</p>
    </Link>
  )
}

export default BalanceAction
